import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./EventCompliance.css";

export function EventCompliance({ percent, missedCount, studyLocked }) {
  const { t } = useTranslation();

  function activeStudy() {
    if (missedCount === 0) {
      return (
        <>
          {t("home.event_compliance.zero_missed")}
          {percent === 100
            ? ` ${t("home.event_compliance.percent", { percent })}.`
            : ""}
        </>
      );
    }

    const missedEventsTranslationKey =
      missedCount === 1
        ? "home.event_compliance.missed_events_one"
        : "home.event_compliance.missed_events_other";

    return (
      <>
        {t("home.event_compliance.percent", { percent })}
        <span className="event-compliance__missed-events">
          {` ${t(missedEventsTranslationKey, { count: missedCount })}`}
        </span>
      </>
    );
  }

  function lockedStudy() {
    return t("home.study_locked");
  }

  return (
    <small
      className={classNames({
        "event-compliance": true,
        "event-compliance--success": !missedCount,
      })}
    >
      {studyLocked ? lockedStudy() : activeStudy()}
    </small>
  );
}

EventCompliance.propTypes = {
  percent: PropTypes.number,
  missedCount: PropTypes.number,
  studyLocked: PropTypes.bool.isRequired,
};
